import { CommonApiFunctions } from '../../../common/constants';
import { message } from 'antd';
import { researchUI } from '../../../api';
import { ERROR_MSG } from '../../Helper/Constant';

export const getDomainById = async (domain_id) => {
    const result = await researchUI({
        function: CommonApiFunctions.COMMON_FUNCTION,
        reqType: CommonApiFunctions.GET_DOMAIN_BY_ID,
        domain_id,
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const rejectDomainChangeRequest = async (id, user) => {
    const result = await researchUI({
        function: CommonApiFunctions.COMMON_FUNCTION,
        reqType: CommonApiFunctions.DOMAIN_CHANGES,
        action: 'REJECT',
        id,
        user,
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};

export const saveDomainChanges = async (data, id, user) => {
    const result = await researchUI({
        function: CommonApiFunctions.COMMON_FUNCTION,
        reqType: CommonApiFunctions.APP_DOMAIN_CHANGE,
        ...data,
        id,
        user,
    }).catch(() => {
        return false;
    });
    if (result.success === 1) {
        return result.data;
    } else {
        message.error(ERROR_MSG.GENERAL_ERROR);
        return false;
    }
};
